export const LONGITUDE = 'longitude'
export const LATITUDE = 'latitude'
export const SITE_MAP_FILE = 'siteMapFile'
export const VALIDATION_STATE = 'validationState'
